//App
import { AgencyContextData, AgencyProps } from "../../../types/agency";
import { AgencyContext } from "../AgencyContainer";
import useForm from "../../hooks/useForm";

const useAgency = (props: AgencyProps) => {
  return useForm<AgencyContextData, AgencyProps>(
    AgencyContext,
    props
  );
};

export default useAgency;
